import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import userService from '../services/userService';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, loading, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) return;
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000';

    // Si el usuario es admin y está en /panel-administrador, redirigir a /panel-administrador/generar-token
    if (user.admin) {
      if (location.pathname === '/panel-administrador') {
        navigate('/panel-administrador/generar-token', { replace: true });
      }
      return;
    }

    // Si el usuario no es admin y está intentando acceder a /panel-administrador
    if (!user.admin && location.pathname.startsWith('/panel-administrador')) {
      userService.getUserToken().then(data => {
        if (data.token) {
          window.location.href = `${apiUrl}/docs`;
        } else {
          logout();
          navigate('/login', { replace: true, state: { error: '¡En estos momentos no tienes un token asignado, contacta a un administrador!' } });
        }
      }).catch(() => {
        logout();
        navigate('/login', { replace: true, state: { error: '¡En estos momentos no tienes un token asignado, contacta a un administrador!' } });
      });
      return;
    }

    // Si el usuario no es admin y está en cualquier otra ruta
    if (!user.admin) {
      userService.getUserToken().then(data => {
        if (data.token) {
          window.location.href = `${apiUrl}/docs`;
        } else {
          logout();
          navigate('/login', { replace: true, state: { error: '¡En estos momentos no tienes un token asignado, contacta a un administrador!' } });
        }
      }).catch(() => {
        logout();
        navigate('/login', { replace: true, state: { error: '¡En estos momentos no tienes un token asignado, contacta a un administrador!' } });
      });
      return;
    }
  }, [user, loading, location, logout, navigate]);

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (requireAdmin && !user.admin) return null;
  return children;
};

export default ProtectedRoute; 